module.exports = __webpack_public_path__ + "static/media/23-1.6efd38a2.mp3";